import { combineReducers } from "redux";
import { categoryReducer } from "./categoryReducer";
import { productReducer } from "./productReducer";
import { serviceReducer } from "./serviceReducer";
import { loggedUserReducer } from "./loggedUderReducer";
import { customerAddressReducer } from "./customerAddress";
import { countReducer } from "./countReducer";
import { wishlistDataReducer } from "./wishlistData";
import { popularServiceReducer } from "./popularServices";
import { cartDataReducer } from "./cartData";
import { orderProductProcessReducer } from "./orderProductProcessReducer";
import { canceledProductReducer } from "./cancledOrderReducer";
import { returnedProductReducer } from "./returnedOrderReducer";
import { bookedServicesReducer } from "./bookedServicesReducer";

const rootReducer = combineReducers({
  categoryState: categoryReducer,
  productState: productReducer,
  serviceState: serviceReducer,
  loggedUserState: loggedUserReducer,
  customerAddressState:customerAddressReducer,
  countState: countReducer,
  wishlistState:wishlistDataReducer,
  popularserviceState:popularServiceReducer,
  cartState:cartDataReducer,
  processProductState:orderProductProcessReducer,
  cancleProductState:canceledProductReducer,
  returnProductState:returnedProductReducer,
  bookedServiceState:bookedServicesReducer,
  //Add more reducer if need
});

export default rootReducer;
